// import { TOGGLE_ADV_FILTERS_COLUMN } from "../actions/advCustomChartAction";

import moment from "moment";
import { isFulfilled } from "./reducerUtils";

const initialState = {
    advFiltersExpanded: false,
    count: 0,
    widgetId: 0,
    widgetName: "",
    chartName: "",
    chartEdited: false,
    multiDimensionChartConfig: {
        dimensionName: "",
        metricName: "",
        breakdownDimensionName: "",
        breakdownMetricName: "",
    },

    onClickDimensionConfig: "",
    onClickMetricConfig: "",
    topTenTopics: [],
    topTenSubTopics: [],

    filters: {
        topics: [],
        subtopics: [],
        countries: ["selectAll"],
        duration: "7",
        platforms: ["selectAll"],
        languages: ["selectAll"],
        publications: [],
        entitySubType: "all",
        entityType: "all",
        endDateTime: null,
        startDateTime: null,
        rollingDate: false,
    },

    filterRefineFilter: {
        sentiment: ["all"],
        sentimentType: "all",
        media: "all",
        postType: "all",
        postSubType: "all",
        sampling: "100",
        channel: "all",
        exclusion: "yes",
    },
    imageAnalyticsFilters: {
        ocr_custom_query: [],
        logos: [],
        scenes: [],
        objects: [],
    },
    // customQuery: "",
};

const advCustomChartReducer = (state = initialState, action) => {
    switch (action.type) {
        case "TOGGLE_ADV_FILTERS_COLUMN": {
            return {
                ...state,
                advFiltersExpanded: action.payload,
            };
        }

        case "CHART_CONFIGURATION_VALUE": {
            const multiDimensionChartConfig = JSON.parse(JSON.stringify(state.multiDimensionChartConfig));
            const count = state.count + 1;

            multiDimensionChartConfig.dimensionName = action.payload.dimensions[0] || "";
            multiDimensionChartConfig.metricName = action.payload.metrics[0] || "";
            multiDimensionChartConfig.breakdownDimensionName = action.payload.dimensions[1] || "";
            multiDimensionChartConfig.breakdownMetricName = action.payload.metrics[1] || "";
            let chartEdited = state.chartEdited;
            chartEdited = false;
            return {
                ...state,
                multiDimensionChartConfig: multiDimensionChartConfig,
                count,
                chartEdited,
            };
        }

        case "UPDATE_DIMENSION_NAME": {
            const multiDimensionChartConfig = state.multiDimensionChartConfig;
            if (action.payload.dimensionName) {
                multiDimensionChartConfig.dimensionName = action.payload.dimensionName;
            }

            if (action.payload.breakdownDimensionName) {
                multiDimensionChartConfig.breakdownDimensionName = action.payload.breakdownDimensionName;
            }

            const count = state.count + 1;

            return {
                ...state,
                multiDimensionChartConfig: multiDimensionChartConfig,
                count,
            };
        }

        case isFulfilled("TOP_TOPICS_BY_DATA"): {
            const { topics, subtopics } = formatTopTopicsBydataUsage(action.payload);
            return { ...state, topTenSubTopics: subtopics || [], topTenTopics: topics || [] };
        }

        case "EDIT_CHART_CONFIGURATION_VALUE": {
            let multiDimensionChartConfig = state.multiDimensionChartConfig;
            const count = state.count + 1;
            multiDimensionChartConfig = action.payload[0];
            let widgetId = state.widgetId;
            widgetId = action.payload.widgetId;
            let widgetName = state.widgetName;
            widgetName = action.payload.widgetName;
            let chartEdited = state.chartEdited;
            chartEdited = true;
            return {
                ...state,
                multiDimensionChartConfig,
                count,
                widgetId,
                widgetName,
                chartEdited,
            };
        }

        case "EDIT_CHART_CONFIGURATION_NAME": {
            let chartName = state.chartName;
            chartName = action.payload;

            return {
                ...state,
                chartName,
            };
        }
        case "EDIT_CHART_WIDGET_CONFIGURATION": {
            let widgetId = state.widgetId;
            widgetId = 0;
            let widgetName = state.widgetName;
            widgetName = "";

            return {
                ...state,
                widgetId,
                widgetName,
            };
        }
        case "EDIT_CHART_EDIT_STATUS": {
            let chartEdited = state.chartEdited;
            chartEdited = false;

            return {
                ...state,
                chartEdited,
            };
        }
        case "ADD_DIMENSION_ON_CLICK": {
            let onClickDimensionConfig = state.onClickDimensionConfig;
            onClickDimensionConfig = action.payload;

            return {
                ...state,
                onClickDimensionConfig,
            };
        }
        case "ADD_METRIC_ON_CLICK": {
            let onClickMetricConfig = state.onClickMetricConfig;
            onClickMetricConfig = action.payload;

            return {
                ...state,
                onClickMetricConfig,
            };
        }

        default:
            return state;
    }
};

export default advCustomChartReducer;

export const formatTopTopicsBydataUsage = (subTopicsList) => {
    let topSubTopicsListIds = [];
    let topTopicsListIds = [];

    subTopicsList.forEach((obj) => {
        obj.subtopics.forEach((subTopicObj) => {
            topSubTopicsListIds.push({
                subtopic_id: subTopicObj.subtopic_id,
                total: subTopicObj.total,
            });
        });
        let count = 0;
        obj.subtopics.forEach((subTopicObj) => {
            count += subTopicObj.total;
        });
        topTopicsListIds.push({
            // ...obj,
            topic_id: obj.topic_id,
            total: count,
        });
    });
    topSubTopicsListIds.sort((a, b) => b.total - a.total).splice(10);
    topSubTopicsListIds = topSubTopicsListIds.map((obj) => obj.subtopic_id);

    topTopicsListIds.sort((a, b) => b.total - a.total).splice(10);
    topTopicsListIds = topTopicsListIds.map((obj) => obj.topic_id);

    return {
        topics: topTopicsListIds,
        subtopics: topSubTopicsListIds,
    };
};
